// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3iBoZ","header":"MessagesList_header__3JKBK","chat":"MessagesList_chat__Lp89W"};